import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { UserMenuSearch } from './UserMenuSearch';

const UserMenuSearchBridge = react2angular(UserMenuSearch, []);
export default UserMenuSearchBridge;
